import type { Match } from '@/api/useSupplierReconciliation'

export function getUnmatchInvoicesAndBols(match: Match) {
  const invoices =
    match.invoice_numbers?.map((inv) => ({
      invoice_number: inv.number,
      invoice_id: inv.id,
    })) || []

  const bols =
    match.bol_numbers?.map((bol) => ({
      bol_number: bol.number,
      bol_id: bol.id,
    })) || []

  return {
    invoices: invoices.length ? [invoices[0]] : [],
    bols: bols.length && !invoices.length ? [bols[0]] : [],
  }
}
